import { render, staticRenderFns } from "./SiteAdminLanding.vue?vue&type=template&id=5b29d7a6&scoped=true"
import script from "./SiteAdminLanding.vue?vue&type=script&lang=ts"
export * from "./SiteAdminLanding.vue?vue&type=script&lang=ts"
import style0 from "./SiteAdminLanding.vue?vue&type=style&index=0&id=5b29d7a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b29d7a6",
  null
  
)

export default component.exports